import React, { useEffect, useState } from "react";
import { FieldArray } from "formik";
import { Grid, Header, Table, Pagination, Input } from "semantic-ui-react";
import { Checkbox } from "formik-semantic-ui";
import moment from "moment";
import PoDetails from "./poDetails";
import { getMappedVendorPurchaseOrder } from "../../redux/actions/purchaseOrderActions";
import { DATE_FORMATS, PO_TITLES } from "../../config/const";

const CheckedPurchaseOrder = ({
  editmode,
  vendorData,
  viewmode,
  masterState,
  vendorStateId,
  updatePurchaseOrder,
  getVendorPurchaseOrder,
  purchaseOrderPaginationData,
  handlePaginationChangeCall,
  purchaseOrderCurrentPageData,
  setInitialize,
  handleSearchStringCall,
  searchTextProps,
  hidePagination,
  billData
}) => {


  const handlePaginationChange = (e, { activePage }) => {
    handlePaginationChangeCall(activePage);
  };

  return (
    <div className="ui form">
      <FieldArray name="mappedPODetails">
        {({ push, remove, form }) => {
          const { values } = form;
          const { mappedPODetails } = values;

          return (
            <>
              <div className="text-center font-weight-bold">
                <span>
                  {PO_TITLES.MAPPED_PO}
                </span>
              </div>
              <Table
                unstackable
                size="large"
                compact="very"
                className="w3-small"
              >
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell className="labelName p-bold-600">
                      PO Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      Order Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      Reference Number
                    </Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-600">
                      PO Date
                    </Table.HeaderCell>
                    {/* <Table.HeaderCell className="labelName p-bold-600">TDS Amount</Table.HeaderCell> */}
                    <Table.HeaderCell className="labelName p-bold-600">
                      Amount
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>

                <Table.Body>
                  {mappedPODetails.map((object, index) => {
                    return (
                      <Table.Row verticalAlign="middle">
                        <React.Fragment>
                          <Table.Cell>
                            {mappedPODetails[index].poNumber}
                            <PoDetails
                              poId={mappedPODetails[index].poId}
                              poReferenceNo={
                                mappedPODetails[index].poReferenceNo
                              }
                              masterState={masterState}
                              vendorStateId={vendorStateId}
                              isGstApplicable={values.isGstApplicable}
                              updatePurchaseOrder={updatePurchaseOrder}
                              getVendorPurchaseOrder={getVendorPurchaseOrder}
                              setInitialize={setInitialize}
                              formValues={values}
                              editmode={editmode}
                              vendorData={vendorData}
                              viewmode={viewmode}
                            />
                          </Table.Cell>
                          <Table.Cell>
                            {mappedPODetails[index].orderNo}
                          </Table.Cell>
                          <Table.Cell>
                            {mappedPODetails[index].poReferenceNo}
                          </Table.Cell>
                          <Table.Cell>
                            {mappedPODetails[index].poDate
                              ? moment(mappedPODetails[index].poDate).format(
                                DATE_FORMATS.DD_MM_YYYY
                              )
                              : "NA"}
                          </Table.Cell>
                          <Table.Cell>
                            {mappedPODetails[index].totalOrderAmt}
                          </Table.Cell>
                        </React.Fragment>
                      </Table.Row>
                    );
                  })}
                </Table.Body>
              </Table>
              <Grid columns={3}>
                <Grid.Row className="p-2">
                  <Grid.Column width={10} />
                  <Grid.Column>
                    {editmode ? (
                      ""
                    ) : (
                      <>
                        <Grid.Row>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName p-bold-600"
                            size="tiny"
                          >
                            Active PO Total
                          </Header>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName"
                            size="tiny"
                          >
                            ₹ {values.activePoAddedTotal}
                          </Header>
                        </Grid.Row>
                        <Grid.Row>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName p-bold-600"
                            size="tiny"
                          >
                            New PO Total
                          </Header>
                          <Header
                            floated="right"
                            as="label"
                            className="labelName"
                            size="tiny"
                          >
                            ₹{" "}
                            {isNaN(values.manualPoAddedTotal)
                              ? "0.00"
                              : values.manualPoAddedTotal}
                          </Header>
                        </Grid.Row>
                      </>
                    )}
                     <Grid.Row>
                      <Header
                        floated="right"
                        as="label"
                        className="labelName p-bold-600"
                        size="tiny"
                      >
                        Total
                      </Header>
                      <Header
                        floated="right"
                        as="label"
                        className="labelName"
                        size="tiny"
                      >
                        ₹ {billData?.[0]?.billAmount}
                      </Header>
                    </Grid.Row>
                  </Grid.Column>
                </Grid.Row>
              </Grid>

              {hidePagination != null ||
                hidePagination != undefined ||
                hidePagination == true ? null : (
                <div
                  style={{ marginLeft: "-15px", borderTop: "0px solid black" }}
                >
                  <Pagination
                    defaultActivePage={
                      purchaseOrderCurrentPageData
                    } 
                    firstItem={null}
                    lastItem={null}
                    onPageChange={handlePaginationChange}
                    pointing
                    secondary
                    totalPages={
                      purchaseOrderPaginationData?.totalPages
                        ? purchaseOrderPaginationData.totalPages
                        : 0
                    }
                  />
                </div>
              )}
            </>
          );
        }}
      </FieldArray>
    </div>
  );
};

export default CheckedPurchaseOrder;
